module.exports = __webpack_public_path__ + "static/media/S (170).412a9a20.jpg";